<template>
  <div class="text-center">
    <v-btn
      :loading="loading3"
      :disabled="loading3"
      color="blue-grey"
      class="ma-2 white--text"
      @click="reset"
    >
      Reset
      <v-icon right dark>fas fa-sync</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
export default {
  props: [ "editor","sleepTime"],
  data() {
    return {
      dateValue: null,
      loader: null,
      loading3: false
    };
  },
  methods: {
    reset() {
      const l = "loading3";
      this[l] = !this[l];
    EventBus.$emit('global-reset-nodes', {});
              setTimeout(() => {
                this[l] = false;
                 if (this.editor !== undefined) this.editor.trigger("process");

              }, this.sleepTime);

    }
  },
  mounted() {}
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>